import Vue from 'vue'
import {filter, whereEq} from 'ramda'

Vue.filter('filterEq', function(value, obj) {
  return filter(whereEq(obj), value)
})
